/** Joins class names, ignoring falsy values. Deliberately smaller than clsx. */
export function cn(...values: (string | false | null | undefined)[]): string {
  return values.filter(Boolean).join(' ');
}
